import { useNavigate } from '@tanstack/react-router';

import { useProfileStore } from '@/shared/store/profileStore';

import { useGetChatProfileQuery } from '../api';
import { useCreateConversationWithAdminMutation } from '../api/create-conversation-with-admin';

export const useCreateDirectChatWithSupport = () => {
  const navigate = useNavigate();
  const { currentSessionId, profile } = useProfileStore();
  const createConversationWithAdminMutation =
    useCreateConversationWithAdminMutation();
  const senderProfile = useGetChatProfileQuery(
    {
      profileId: currentSessionId?.toString()!,
      profileType: profile?.role!
    },
    {
      options: {
        enabled: !!(currentSessionId && profile)
      }
    }
  );

  const createConversation = async () => {
    if (senderProfile.data?.data.chatProfileId) {
      await createConversationWithAdminMutation.mutateAsync(
        {
          params: {
            senderProfileId: senderProfile.data?.data.chatProfileId.toString()
          }
        },
        {
          onSuccess: (response) => {
            navigate({
              to: '/conversation/$conversationId',
              params: {
                conversationId: response.data.conversationId.toString()
              }
            });
          }
        }
      );
    }
  };

  return {
    createConversation
  };
};
